export default __webpack_public_path__ + "1fa44c67c69da440c8b69b9e6a61be24.png";